module.exports = __webpack_public_path__ + "img/content2.ceeafe2e.png";